export default "data:image/gif;base64,R0lGODlhEgAMAPEBAADNAP////8AAOXl5SH5BAAAAAAALAAAAAASAAwAAAIdlI+py+2vRpi02jDk3TNz7n3XAJTmiabqyrZuWgAAOw=="